import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { TaskFileGroupInterface } from './definitions/task-file-group-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface ApproveTaskFileGroupResponse {
  taskFileGroup: {
    assume: {
      output: TaskFileGroupInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class ApproveTaskFileGroupService {
  constructor(private apollo: Apollo) {}

  approve(
    taskFileGroupId: string,
    mutation: DocumentNode
  ): Observable<FetchResult<ApproveTaskFileGroupResponse>> {
    return this.apollo.mutate<ApproveTaskFileGroupResponse>({
      mutation: mutation,
      variables: {
        id: taskFileGroupId,
      },
    });
  }
}
